import {
    Component,
    ElementRef,
    inject,
    Input,
    OnDestroy,
    OnInit,
    output,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixDialogService } from "./cerrix-dialog-service.component";
import { MatIcon } from "@angular/material/icon";
import { TabService } from "@services/tabs/TabService";

@Component({
    selector: "cerrix-dialog",
    imports: [MatIcon],
    templateUrl: "./cerrix-dialog.component.html",
    styleUrl: "./cerrix-dialog.component.scss",
    encapsulation: ViewEncapsulation.None,
    host: {
        "[class.open]": "dialogOpen",
    },
})
export class CerrixDialogComponent implements OnInit, OnDestroy {
    private elementRef = inject(ElementRef);
    private tabs = inject(TabService);

    dialogOpen: boolean = false;
    tabId: string;
    @Input() name: string = "";
    @Input() icon: string;

    /** Always emits when a dialog is closed, independent of the action that closed it. */
    readonly closed = output<void>();

    _dialogService = inject(CerrixDialogService);

    ngOnInit(): void {
        // A nested cerrix-dialog inside an @if-gated [dialog-content] slot may not have a
        // tab-pane ancestor when ngOnInit runs. It still belongs to the active tab, so fall
        // back to that rather than register with an undefined tabId.
        const currentTab = this.elementRef.nativeElement.closest("tab-pane");
        this.tabId = currentTab?.getAttribute("id") ?? this.tabs.activeTab.identifier;
        this._dialogService.addDialog(this, this.tabId);
    }

    ngOnDestroy(): void {
        this._dialogService.removeDialog(this, this.tabId);
    }

    openDialog() {
        this.dialogOpen = true;
    }

    closeDialog() {
        // The service falls back to closing the tab's first dialog, which may not be open.
        if (!this.dialogOpen) return;

        this.dialogOpen = false;
        this.closed.emit();
    }
}
